import { type ReactNode, type CSSProperties } from 'react';
import * as RadixCollapsible from '@radix-ui/react-collapsible';
import { clsx } from 'clsx';
import { collapsibleContent } from './collapsible.css';

export { collapsibleChevron, collapsibleTrigger } from './collapsible.css';

export interface CollapsibleProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trigger: ReactNode;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  contentClassName?: string;
  contentStyle?: CSSProperties;
  /** Extra props on the root element */
  'data-testid'?: string;
  disabled?: boolean;
}

export function Collapsible({
  open,
  onOpenChange,
  trigger,
  children,
  className,
  style,
  contentClassName,
  contentStyle,
  'data-testid': testId,
  disabled = false,
}: CollapsibleProps) {
  return (
    <RadixCollapsible.Root
      open={open}
      onOpenChange={onOpenChange}
      className={className}
      style={style}
      data-testid={testId}
      disabled={disabled}
    >
      <RadixCollapsible.Trigger asChild>
        {trigger}
      </RadixCollapsible.Trigger>
      <RadixCollapsible.Content
        className={clsx(collapsibleContent, contentClassName)}
        style={contentStyle}
      >
        {children}
      </RadixCollapsible.Content>
    </RadixCollapsible.Root>
  );
}
